import React, { useEffect, useState } from "react";
import { useAuth } from "../contexts/AuthContext"; // if you have auth context
import axiosInstance from "../axiosInstance";
import Sidebar from "../components/Sidebar"; // show your normal sidebar

function OrgAdminDashboard() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    axiosInstance.get("/org/stats") // or /agency/stats
      .then(res => setStats(res.data))
      .catch(err => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <p>Loading org stats...</p>;
  if (error) return <p style={{ color: "red" }}>{error}</p>;

  return (
    <div style={{ display: "flex" }}>
      <Sidebar /> {/* Keep your sidebar visible */}
      <div style={{ flex: 1, padding: "1rem" }}>
        <h1>Org Admin Dashboard</h1>
        {stats && (
          <div>
            <p>Organization: {stats.orgName}</p>
            {stats.logoUrl && (
              <p>
                <img src={stats.logoUrl} alt="Logo" style={{ height: 50 }} />
              </p>
            )}
            <p>Token Usage: {stats.tokenUsage} / {stats.tokenLimit}</p>
            <p>User Count: {stats.userCount}</p>
          </div>
        )}
        {/* Provide links or modals for user management, branding, etc. */}
      </div>
    </div>
  );
}

export default OrgAdminDashboard;
